import React from "react";
import SystemGraphs from "./SystemGraphs";

const LLResOps = () => {
  const defaultParameter = 67;

  const pageTitle = "LL Res Ops";

  const endpoints = [
    { label: "15 Minutes", value: "display003-data15-min-ax1" },
    { label: "Daily", value: "display003-data-daily-ax1" },
  ];

  const parametersEndpoint = "display003-lookup-parameter";

  const mapEndpoint = "display003-map-points";

  return (
    <>
      <SystemGraphs
        defaultParameter={defaultParameter}
        pageTitle={pageTitle}
        endpoints={endpoints}
        parametersEndpoint={parametersEndpoint}
        mapEndpoint={mapEndpoint}
        //if rightAxis is true, then the graph will add a right axis based on the
        //current endpoints, only it will sub a 2 on the end instead of the 1
        rightAxis={true}
        displayIndex="003"
      />
    </>
  );
};

export default LLResOps;
